import * as types from './mutations-types'
import {
  Auth,
  Common
} from '../api'

export default {
  login: async ({ commit }, authInfo) => {
    await Auth.login(authInfo)
      .then((result) => {
        localStorage.setItem('mptoken', result.token)
        commit(types.AUTH_LOGIN, result)
      })
  },

  logout: async ({ commit, state }) => await Auth.logout()
    .then(() => {
      localStorage.removeItem('mptoken')
      commit(types.AUTH_LOGOUT, { token: null, userId: null })
    }),

  authClear: ({ commit, state }) => {
    localStorage.removeItem('mptoken')
    commit(types.AUTH_LOGOUT, { token: null, userId: null })
  },

  checkAuthToken: async ({ commit }) => {
    await Auth.checkAuthToken()
      .then((result) => {
        commit(types.AUTH_TOKEN, result)
      })
  },

  setAuthToken: ({ commit }, params) => {
    // Tokenセット（外部連携先からの仮パスワード変更）
    localStorage.setItem('mptoken', params.token)
    commit(types.AUTH_TOKEN, params)
  },

  codeDef: async ({ commit, state }, params) => {
    const codeDefList = await Common.codeDefList()
    commit(types.CODE_DEF_LIST, codeDefList)
  },

  isLoading: ({ commit, state }, params) => {
    commit(types.IS_LOADING, params)
  },

  langChange: ({ commit, state }, params) => {
    // 言語切り替え
    commit(types.IS_LANG_JA, params === 'ja')
  },

  formAdminAccountEntryList: ({ commit, state }, params) => {
    // 管理者:アカウント申請一覧検索条件
    commit(types.FORM_ADMIN_ACCOUNT_ENTRY_LIST, params)
  },

  formAdminAccountList: ({ commit, state }, params) => {
    // 管理者:アカウント一覧検索条件
    commit(types.FORM_ADMIN_ACCOUNT_LIST, params)
  },

  formAdminMstCompanyList: ({ commit, state }, params) => {
    // 管理者:会社一覧検索条件
    commit(types.FORM_ADMIN_MST_COMANY_LIST, params)
  },

  formAdminAccountServiceApplicationList: ({ commit, state }, params) => {
    // 管理者:アカウント一覧検索条件
    commit(types.FORM_ADMIN_ACCOUNT_SERVICE_APPLICATION_LIST, params)
  },

  fromAddressList: ({ commit, state }, params) => {
    // 管理者:一斉メール送信Fromアドレス
    commit(types.FROM_ADDRESS_LIST, params)
  },

  setManualUrl: async ({ commit }) => {
    // マニュアルURL
    const response = await Common.manualUrl()
    commit(types.SET_MANUAL_URL, response.manualUrl)
  }

}
